<template>
	<main>
		<slot name="header">
            <!-- <section class="flex justify-between w-full items-center mb-4">
                <h5 class="mr-6"><strong class="text-primary">Qurban</strong></h5>
                <router-link to="/zxcare/qurban" class="text-primary">
                    <small>Lihat Semua &nbsp;&nbsp;&nbsp;>></small>
                </router-link>
            </section> -->
        </slot>
		<section class="vx-row mb-6">
			<slot name="content" :datas="data">
				<div 
					class="vx-col w-full md:w-1/2 lg:w-1/3 mb-6"
					v-for="(qurban, i) in data"
					:key="i"
				>
					<vx-card class="p-0">
						<div 
							slot="no-body" 
							class="hidden md:block vx-col w-1/3 md:w-full h-56 md:h-64 card-img-top"
							:style="{ backgroundImage: `url('${imageLink(qurban)}')`, backgroundSize: 'cover' }" 
							@click="$router.push(`/qurban/view/${ createSlugLink(qurban.name, qurban.id) }`)"
						>
						</div>
						<router-link :to="`/qurban/view/${ createSlugLink(qurban.name, qurban.id) }`">
						<div class="vx-row">
							<div 
								class="vx-col w-1/3 block md:hidden h-56 cursor-pointer card-img-top"
								:style="{ backgroundImage: `url('${imageLink(qurban)}')`, backgroundSize: 'cover' }" 
							>
							</div>
							<div class="vx-col w-2/3 md:w-full" >
								<p class="mb-2" style="height: 3rem;overflow: auto;"><strong>{{qurban.name}}</strong></p>
								<p class="mb-2">
									<small>
										{{ qurban.user ? qurban.user.name : '-' }}
									</small>
								</p>
								<div class="flex flex-row md:flex-col lg:flex-row items-end justify-between mb-2">
									<div class="w-2/3 md:w-full lg:w-2/3 mb-0 md:mb-2 lg:mb-0">
										<h4>

											<strong class="text-warning">
												Rp {{ formatRupiah(qurban.nominal) }}
											</strong>
										</h4>
									</div>
									<div class="text-right md:text-left lg:text-right w-1/3 md:w-full lg:w-1/3 overflow-auto">
										<small><strong>{{ qurban.berat ? qurban.berat : '' }}</strong></small>
									</div>
								</div>
							</div>
						</div>
						</router-link>
					</vx-card>	
				</div>	
			</slot>
		</section>
		<footer>
			<slot name="footer"></slot>
		</footer>
	</main>
	
</template>
<script >
import {defaultImage} from '@/assets/utils/qurban'
export default {
  props: ['data', 'total'],
  data: () => ({
	  isZxCare: false
  }),
  methods: {
    imageLink (campaign) {
      if (campaign.file !== null) {
        return `${process.env.VUE_APP_STORAGE  }/${  campaign.file}`
      }
				
      return defaultImage
    },
    remainDay (campaign) {
      const mulai = new Date(campaign.mulai),
        selesai = new Date(campaign.selesai),
        timeDifferent = selesai.getTime() - mulai.getTime(),
        dayMilsec = 1000 * 60 * 60 * 24

      return timeDifferent / dayMilsec
    }
  }
}
</script>